<template>
  <v-col :md="cols" :order="order" align-self="center">
    <v-card
      rounded
      class="mx-auto"
      max-width="600"
      :width="$vuetify.breakpoint.mdAndUp ? '80%' : '100%'"
    >
      <v-speed-dial
        v-model="fab"
        absolute=""
        top
        right
        direction="bottom"
        :open-on-hover="true"
        transition="scale"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          color="blue"
          small
          @click="downloadFile({ url: item.url, name: name, ext: ext })"
          ><v-icon>mdi-download</v-icon></v-btn
        >
        <v-btn fab color="blue" small :href="item.url" target="_blank"
          ><v-icon>mdi-open-in-new</v-icon></v-btn
        >
        <v-btn fab dark small color="#730D0B" @click="onDelete">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-speed-dial>
      <v-img aspect-ratio="1" v-if="type === 'image'" :src="item.url">
        <template v-slot:placeholder>
          <v-row
            class="primary fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row> </template
      ></v-img>
      <vue-plyr v-if="type === 'video'">
        <video :src="item.url">
          <source :src="item.url" :type="`video/${ext}`" size="720" />
        </video>
      </vue-plyr>
      <vue-plyr v-if="type === 'audio'">
        <audio :src="item.url">
          <source :src="item.url" :type="`audio/${ext}`" />
        </audio>
      </vue-plyr>
      <v-card-title v-text="`${type} - ${name}`"> </v-card-title>

      <v-card-actions v-if="item.details && item.details.length > 0">
        <v-btn @click="show = !show" text color="primary">
          Details
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>

          <v-card-text>
            {{ item.details }}
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </v-col>
</template>

<script>
import downloadLogic from "@/mixins/downloadLogic";
export default {
  mixins: [downloadLogic],
  props: ["item", "index"],
  data: () => ({
    type: "",
    name: "",
    ext: "",
    fab: false,
    show: false
  }),
  mounted: function() {
    const arrayLink = this.item?.url?.split("%2F");
    this.type = arrayLink[2];
    const getName = arrayLink[3].split(".");
    this.name = getName[0];
    const getExtension = getName[1].split("?");
    this.ext = getExtension[0];
  },
  computed: {
    cols() {
      return 12;
    },
    order: function() {
      return this.type === "video" ? 1 : this.type === "audio" ? 2 : 3;
    }
  },
  methods: {
    onDelete: function() {
      this.$emit("remove");
      this.$emit(
        "delete",
        this.item,
        this.type,
        `${this.name}.${this.ext}`,
        this.index
      );
    }
  }
};
</script>
